import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const container = document.getElementById('app');
const external_container = document.getElementById('app-external');


let clientId;
let productId;

if(external_container) {
  clientId = document.getElementById('app-external').getAttribute('data-clientId');
  productId = document.getElementById('app-external').getAttribute('data-productId');
} else { 
  clientId = document.getElementById('app').getAttribute('data-clientId');
  productId = document.getElementById('app').getAttribute('data-productId');
}

// clientId=9;

if( container !== null ){
  ReactDOM.render(<App clientId={clientId} />, container);
}else if ( external_container !== null ) {
  ReactDOM.render(<App clientId={clientId} productId={productId} isExternal={true} />, external_container);
}



// WEBPACK FOOTER //
// ./src/index.js